/**
 * Why a founder can see a given investor.
 *
 * A leaf module — no react-query, no supabase client — so the labels can be
 * tested without the native dependency graph, and so the SQL contract has one
 * place to be mirrored.
 *
 * The values mirror the `relationship` column returned by
 * `get_related_investors()`. They are a union rather than `string` so that
 * renaming one server-side fails the build instead of rendering `undefined`
 * into a badge.
 */

export type InvestorRelationship =
  | 'portfolio'
  | 'due_diligence'
  | 'data_room'
  | 'conversation';

/**
 * Ordered strongest first, matching the SQL's tie-break. An investor who both
 * asked for the data room and later invested is described by the investment.
 */
export const INVESTOR_RELATIONSHIPS: InvestorRelationship[] = [
  'portfolio',
  'due_diligence',
  'data_room',
  'conversation',
];

/** Human wording, from the founder's point of view. */
export const RELATIONSHIP_LABELS: Record<InvestorRelationship, string> = {
  portfolio: 'Invested in you',
  due_diligence: 'Running due diligence',
  data_room: 'Requested your data room',
  conversation: 'In conversation',
};
